import React from "react";

export default function ChannelSliderArrow({ currentSlide }: any) {
  return <div aria-label={currentSlide} />;
}
